// extracted by mini-css-extract-plugin
module.exports = {"header":"AuthHeaderV2_header__TO7Dv","back-icon":"AuthHeaderV2_back-icon__MNAh6"};